export default __webpack_public_path__ + "static/media/location-icon.14d5e383.svg";